<template>
  <div>
    <!-- Header -->
    <base-header class="pb-8 pt-6">
      <!-- Card stats -->
      <b-row>
        <b-col md="3">
          <button @click="$router.go()" class="btn btn-info btn-sm mb-3">
            Nueva Factura
          </button>
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--8">
      <b-row class="justify-content-center">
        <b-col lg="12" md="12">
          <b-card no-body class="border-0 mb-0 shadow">
            <b-card-body v-if="download.uuid">
              <!-- <b-card-body> -->
              <h2 class="text-center">
                La factura
                <span class="text-primary">{{ download.uuid }}</span> ha sido
                enviada al correo.
                <strong>{{ receptor.email }}</strong>
              </h2>
              <div class="d-block text-center">
                <a
                  :href="`${$backend}/api/facturacion/descargar/${download.uuid}`"
                  download
                  class="text-dark btn btn-success btn-sm"
                  ><i class="far fa-download"></i> Descargar factura</a
                >
                <!-- </div>
              <div class="mt-2"> -->
                <b-button
                  :href="`${$backend}/api/facturacion/cfdi/${download.uuid}/recuperar-pdf`"
                  variant="info"
                  size="sm"
                  class="text-primary"
                  target="_blank"
                  download
                >
                  <i class="fas fa-file-pdf mr-1"></i>PDF
                </b-button>
                <b-button
                  :href="`${$backend}/api/facturacion/cfdi/${download.uuid}/recuperar-xml`"
                  variant="info"
                  size="sm"
                  class="text-primary"
                  target="_blank"
                  download
                >
                  <i class="fas fa-file-excel mr-1"></i>XML
                </b-button>
                <b-button
                  :href="`${$backend}/api/facturacion/cfdi/${download.uuid}/recuperar-pdf-ticket`"
                  variant="info"
                  size="sm"
                  class="text-primary"
                  target="_blank"
                  download
                >
                  <i class="fas fa-file-pdf mr-1"></i>PDF Ticket
                </b-button>
                <!-- <b-button
                  :href="`${$backend}/api/facturacion/descargar/${download.uuid}`"
                  variant="info"
                  size="sm"
                  class="text-primary"
                  target="_blank"
                  download
                >
                  <i class="fas fa-download mr-1"></i>Descargar ZIP
                </b-button> -->
                <b-button
                  @click="sendEmail(download.uuid)"
                  class="btn btn-sm btn-info text-primary"
                  ><i class="fas fa-paper-plane mr-1"></i>Enviar por
                  Email</b-button
                >
                <hr class="my-2" />
              </div>
            </b-card-body>
            <b-card-body v-if="!download.uuid" class="px-lg-3 py-lg-3">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <!-- <b-row>
                    <b-col>
                      <b-form-group
                        class="col-md-4 float-right text-right"
                      >
                        <base-checkbox v-model="params.remember">Recordar Configuración</base-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="12" class="d-flex justify-content-between">
                      <h4 class="text-primary">Receptor</h4>
                      <base-checkbox v-model="remember"
                        >Recordar Configuración</base-checkbox
                      >
                    </b-col>
                  </b-row>
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >RFC</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="RFC"
                        @change="configStore"
                        class="text-uppercase form-control-solid"
                        v-model="receptor.rfc"
                        @keyup="loadFiscalData"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Nombre</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="Nombre"
                        @change="configStore"
                        class="text-uppercase form-control-solid"
                        v-model="receptor.nombre"
                      ></b-form-input>
                    </div>
                  </div>
                  
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Código Postal</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-input
                        size="sm"
                        type="number"
                        placeholder="Código Postal"
                        @change="configStore"
                        class="text-uppercase form-control-solid"
                        v-model="receptor.cp"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Regimen Fiscal</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-select
                        v-model="receptor.regimen_fiscal"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="601"
                          >General de Ley Personas Morales</b-form-select-option
                        >
                        <b-form-select-option value="603"
                          >Personas Morales con Fines no
                          Lucrativos</b-form-select-option
                        >
                        <b-form-select-option value="605"
                          >Sueldos y Salarios e Ingresos Asimilados a
                          Salarios</b-form-select-option
                        >
                        <b-form-select-option value="606"
                          >Arrendamiento</b-form-select-option
                        >
                        <b-form-select-option value="608"
                          >Demás ingresos</b-form-select-option
                        >
                        <b-form-select-option value="609"
                          >Consolidación</b-form-select-option
                        >
                        <b-form-select-option value="610"
                          >Residentes en el Extranjero sin Establecimiento
                          Permanente en México</b-form-select-option
                        >
                        <b-form-select-option value="611"
                          >Ingresos por Dividendos (socios y
                          accionistas)</b-form-select-option
                        >
                        <b-form-select-option value="612"
                          >Personas Físicas con Actividades Empresariales y
                          Profesionales</b-form-select-option
                        >
                        <b-form-select-option value="614"
                          >Ingresos por intereses</b-form-select-option
                        >
                        <b-form-select-option value="616"
                          >Sin obligaciones fiscales</b-form-select-option
                        >
                        <b-form-select-option value="620"
                          >Sociedades Cooperativas de Producción que optan por
                          diferir sus ingresos</b-form-select-option
                        >
                        <b-form-select-option value="621"
                          >Incorporación Fiscal</b-form-select-option
                        >
                        <b-form-select-option value="622"
                          >Actividades Agrícolas, Ganaderas, Silvícolas y
                          Pesqueras</b-form-select-option
                        >
                        <b-form-select-option value="623"
                          >Opcional para Grupos de
                          Sociedades</b-form-select-option
                        >
                        <b-form-select-option value="624"
                          >Coordinados</b-form-select-option
                        >
                        <b-form-select-option value="626"
                          >Régimen Simplificado de Confianza</b-form-select-option
                        >
                        <b-form-select-option value="628"
                          >Hidrocarburos</b-form-select-option
                        >
                        <b-form-select-option value="607"
                          >Régimen de Enajenación o Adquisición de
                          Bienes</b-form-select-option
                        >
                        <b-form-select-option value="629"
                          >De los Regímenes Fiscales Preferentes y de las
                          Empresas Multinacionales</b-form-select-option
                        >
                        <b-form-select-option value="630"
                          >Enajenación de acciones en bolsa de
                          valores</b-form-select-option
                        >
                        <b-form-select-option value="615"
                          >Régimen de los ingresos por obtención de
                          premios</b-form-select-option
                        >
                        <b-form-select-option value="625"
                          >Régimen de las Actividades Empresariales con ingresos
                          a través de Plataformas
                          Tecnológicas</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Email</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="Email"
                        @change="configStore"
                        class="text-lowercase form-control-solid"
                        v-model="receptor.email"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Confirmar Email</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="Confirmar Email"
                        @change="configStore"
                        class="text-lowercase form-control-solid"
                        v-model="receptor.email_confirm"
                      ></b-form-input>
                    </div>
                  </div>

                  <b-row>
                    <b-col md="12">
                      <h4 class="text-primary">Parámetros CFDI</h4>
                    </b-col>
                  </b-row>

                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Uso CFDI</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-select
                        v-model="cfdi.uso"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="G03"
                          >Gastos en General</b-form-select-option
                        >
                        <b-form-select-option value="P01"
                          >Por Definir</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>

                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Tipo Consumo</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-select
                        v-model="cfdi.tipo"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="90101500"
                          >Establecimientos para comer y
                          beber</b-form-select-option
                        >
                        <b-form-select-option value="90101800"
                          >Servicios de comida para llevar y a
                          domicilio</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>

                  <div class="form-group row mb-1">
                    <label
                      for="colFormLabelSm"
                      class="col-sm-3 col-md-3 col-lg-2 col-form-label col-form-label-sm"
                      >Método de Pago</label
                    >
                    <div class="col-sm-9 col-md-8 col-lg-6">
                      <b-form-select
                        v-model="cfdi.metodo_pago"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="01"
                          >Efectivo</b-form-select-option
                        >
                        <b-form-select-option value="04"
                          >Tarjeta de Crédito</b-form-select-option
                        >
                        <b-form-select-option value="28"
                          >Tarjeta de Débito</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>

                  <hr class="mt-0 mb-2" />

                  <b-row>
                    <b-col md="12">
                      <h4 class="text-primary">Mis Tickets</h4>
                    </b-col>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1 small"
                      label="Sucursal"
                    >
                      <b-form-select
                        v-model="element.sucursal_id"
                        :disabled="Boolean(tickets.length)"
                        class="text-uppercase"
                        size="sm"
                        @change="configStore"
                      >
                        <b-form-select-option
                          v-for="(sucursal, ks) in sucursales"
                          :key="ks"
                          :value="sucursal.id"
                          >{{ sucursal.nombre }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1 small"
                      label="Serie"
                    >
                      <b-form-select
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="text"
                        placeholder="Serie"
                        v-model="element.serie"
                      >
                        <b-form-select-option
                          v-for="(item, ks) in sucursalSeries"
                          :key="ks"
                          :value="item.serie"
                          >{{ item.serie_public }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1 small"
                      label="Folio"
                    >
                      <b-form-input
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="number"
                        placeholder="Folio"
                        class="text-uppercase form-control-solid"
                        step="1"
                        v-model="element.folio"
                        min="0"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1 small"
                      label="Total"
                    >
                      <b-form-input
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="number"
                        placeholder="Total"
                        class="text-uppercase form-control-solid"
                        v-model="element.total"
                        min="0"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-2 mb-3">
                      <b-button
                        @click="addTicket"
                        :disabled="working"
                        class="mt-4 py-2"
                        variant="primary"
                        size="sm"
                        block
                        >Agregar Ticket</b-button
                      >
                    </b-form-group>
                    <b-col md="12">
                      <b-table
                        borderless
                        thead-class="text-dark"
                        :fields="fields"
                        :items="tickets"
                        small
                      ></b-table>
                      <hr class="mt-0 mb-2" />
                      <b-alert
                        v-if="error.length"
                        show
                        variant="danger"
                        class="mt-2 mb-2 text-center"
                      >
                        <span
                          v-for="(e, k) in error"
                          :key="k"
                          v-html="e"
                        ></span>
                      </b-alert>
                      <b-button
                        @click="generar"
                        :disabled="!Boolean(tickets.length) || working"
                        variant="primary"
                        block
                        >Generar Factura</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      working: false,
      error: [],
      remember: false,
      sucursales: [],
      element: {
        sucursal_id: "",
        serie: "",
        folio: "",
        total: "",
      },
      receptor: {
        nombre: "",
        rfc: "",
        cp: "",
        regimen_fiscal: "",
        email: "",
        email_confirm: "",
      },
      cfdi: {
        uso: "",
        tipo: "",
        metodo_pago: "",
      },
      download: {
        uuid: "",
      },
      fields: [
        {
          key: "FECHA",
          label: "Fecha",
          formatter: (value, key, item) => {
            return moment(value).utc().format("DD-MM-YYYY");
          },
        },
        {
          key: "NUMALBARAN",
          label: "Folio",
        },
        {
          key: "NUMSERIE",
          label: "Serie",
        },
        {
          key: "TOTALNETO",
          label: "Total",
        },
      ],
      tickets: [],
    };
  },
  watch: {
    remember: function (val) {
      localStorage.setItem("remember", val);
      if (!val) {
        localStorage.removeItem("receptor");
        localStorage.removeItem("cfdi");
        localStorage.removeItem("sucursal");
      } else {
        localStorage.setItem("receptor", JSON.stringify(this.receptor));
        localStorage.setItem("cfdi", JSON.stringify(this.cfdi));
        localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
      }
    },
  },
  computed: {
    sucursalSeries() {
      let sucursal = this.sucursales.find(
        (sucursal) => sucursal.id == this.element.sucursal_id
      );

      return sucursal ? sucursal.series : [];
    },
  },
  beforeMount() {
    this.remember = localStorage.getItem("remember") == "true";

    this.getSucursales();
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    getSucursales() {
      this.$api
        .get("/facturacion/sucursales")
        .then((response) => {
          this.sucursales = response.data;
        })
        .catch((e) => console.error(e));
    },
    loadConfig() {
      if (
        localStorage.getItem("remember") != undefined &&
        localStorage.getItem("remember") == "true"
      ) {
        this.receptor = JSON.parse(localStorage.getItem("receptor"));
        this.element.sucursal_id = localStorage.getItem("sucursal");
        this.cfdi = JSON.parse(localStorage.getItem("cfdi"));
      }

      if (localStorage.getItem("facturacion-config") != null) {
        this.params = JSON.parse(data);
      } else {
        this.resetSchemaParams();
      }
    },
    schemaParams() {
      return {
        remember: false,
        sucursal: "",
        nombre: "",
        rfc: "",
        email: "",
        cfdi_uso: "",
        cfdi_tipo: "",
        cfdi_pago: "",
      };
    },
    schemaElement() {
      return {
        sucursal_id: "",
        serie: "",
        folio: "",
        total: "",
      };
    },
    resetSchemaParams() {
      this.params = this.schemaParams();
    },
    resetElement() {
      this.element = this.schemaElement();
    },
    validationTicket(ticket) {
      return new Promise((resolve, reject) => {
        // Verificar serie del ticket

        // Verificar ticket duplicado
        if (this.tickets.find((item) => item.NUMALBARAN == ticket.folio)) {
          reject("Ya existe un ticket con el mismo folio.");
        }

        resolve(true);
      });
    },
    async addTicket() {
      try {
        this.working = true;
        this.error = [];

        await this.validationTicket(this.element);

        let response = await this.$api.get("/facturacion/ticket/buscar", {
          params: this.element,
        });

        if (!response.data) throw "Ticket no localizado";

        this.element.folio = "";
        this.element.total = "";
        this.tickets.push(response.data[0]);

        this.working = false;
      } catch (error) {
        this.error.push(error.response.data.errors[0] || error.response.data);
        this.$notiflix.Notify.failure(
          error.response.data.errors[0] || error.response.data
        );
        this.working = false;
      }
    },
    generar() {
      this.working = true;
      this.error = [];

      this.$api
        .post(`/facturacion/${this.element.sucursal_id}/generar-factura`, {
          receptor: this.receptor,
          cfdi: this.cfdi,
          tickets: this.tickets,
        })
        .then((res) => {
          this.download = res.data;
        })
        .catch((e) => {
          this.error.push(e.response.data.errors);
          this.$notiflix.Notify.failure(e.response.data.errors[0]);
        })
        .then(() => {
          this.working = false;
        });
    },
    configStore() {
      if (this.remember) {
        localStorage.setItem("receptor", JSON.stringify(this.receptor));
        localStorage.setItem("cfdi", JSON.stringify(this.cfdi));
        localStorage.setItem(
          "sucursal",
          JSON.stringify(this.element.sucursal_id)
        );
      }
    },
    sendEmail(uuid) {
      let mail = prompt(`Ingrese el destinatario`);

      let regex = new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}");

      if (!regex.test(mail)) {
        this.$notiflix.Notify.failure(
          "El correo no cumple con el formato correcto."
        );
        return;
      }

      this.$api
        .post(`facturacion/cfdi/${uuid}/send-mail`, {
          recipients: [mail],
        })
        .then((response) => {
          this.$notiflix.Notify.success("Cfdi enviado.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
    async loadFiscalData() {
      try {
        if(this.receptor.rfc.length < 12) return;

        const rfc = this.receptor.rfc;

        const { data } = await this.$api.get(`/facturacion/${rfc}/data`);

        // Preguntar al usuario si desea cargar los datos fiscales
        if (!confirm(`¿ Desea cargar los datos fiscales ? \n ${data.nombre} \n ${data.RegimenFiscalReceptor} \n ${data.DomicilioFiscalReceptor}`)) return;

        this.receptor.nombre = data.nombre;
        this.receptor.cp = data.DomicilioFiscalReceptor;
        this.receptor.regimen_fiscal = data.RegimenFiscalReceptor;
        this.cfdi.uso = data.UsoCFDI;
        this.cfdi.tipo = data.claveProdServ;
      } catch (error) {
        console.log(error);
      } finally {
        // this.configStore();
      }
    },
  },
};
</script>
<style lang="scss">
.small {
  font-size: 0.75em;
}
.table {
  thead {
    background: #fefee8;

    tr {
      th {
        padding: 0.25rem 0.75rem;
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.25rem 0.75rem;
      }
    }
  }
}
</style>
